import {
  ChannelAvatar,
  CheckboxCard,
  type CheckedState,
  Flex,
  Text,
} from '@buffer-mono/popcorn'

import type { ChannelNavChannel } from '~publish/components/PublishSidebar/useChannels'

import styles from './ChannelListItem.module.css'

const ChannelListItem = ({
  channel,
  onChange,
  selected,
}: {
  channel: ChannelNavChannel
  onChange: (channelId: string, checked: CheckedState) => void
  selected: boolean
}): JSX.Element => {
  return (
    <CheckboxCard
      onCheckedChange={(checked): void => onChange(channel.id, checked)}
      checked={selected}
      className={styles.channelListItem}
    >
      <ChannelAvatar
        alt={channel.name}
        channel={channel.service}
        src={channel.avatar}
        size="small"
      />
      <Flex direction="column" gap="3xs">
        <Text weight="medium">{channel.name}</Text>
        <p className={styles.channelInfo}>
          {channel.service} {channel.type}
        </p>
      </Flex>
    </CheckboxCard>
  )
}

export default ChannelListItem
